import { Modal } from "antd";
import { useCallback, useState } from "react";
import { useHttp } from "./useHttp";
import { useNotification } from "./useNotification";

export function useDeleteModal(props) {
  const { headingText, actionText, cancelText, text, refreshTrigger, pageRef } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [textContent, setTextContent] = useState(text);
  const [url, setUrl] = useState("");
  const notification = useNotification();

  const open = () => setIsOpen(true);
  const close = useCallback(() => setIsOpen(false), []);

  const { request, loading } = useHttp();

  const onSubmit = useCallback(() => {
    close();
    refreshTrigger();
    request({ url, method: "DELETE" })
      .then(() => {
        notification.success({
          message: "Item deleted successfully",
          placement: "bottomRight",
        });
        refreshTrigger();
      })
      .catch((e) => {
        console.error(e, "ERROR");
        notification.error({
          message: "Delete failed",
          placement: "bottomRight",
        });
      });
  }, [request, url, refreshTrigger, notification.error, notification.success]);

  const element = useCallback(
    () => (
      <Modal
        open={isOpen}
        title={headingText}
        okText={actionText || "Ok"}
        cancelText={cancelText || "Cancel"}
        onOk={onSubmit}
        onCancel={close}
        okButtonProps={props?.okButtonProps}
      >
        {loading ? <div>hello</div> : textContent}
      </Modal>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isOpen, headingText, actionText, cancelText, props.okButtonProps, textContent, onSubmit, loading],
  );
  return {
    element,
    loading,
    visibility: { open, close },
    setData: { setTextContent, setUrl },
  };
}
